import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IPublishOnboardingChallengesResponse } from './publish-onboarding-challenges-response';
import { publishOnboardingChallengesResponseSchema } from './publish-onboarding-challenges-response';

export async function publishOnboardingChallengesApi(): Promise<
  IValidatedResponse<IPublishOnboardingChallengesResponse>
> {
  return postRequest<IPublishOnboardingChallengesResponse>({
    path: '/sys/challenges/publish-onboarding',
    schema: publishOnboardingChallengesResponseSchema,
  });
}
